export const isStudioUser = userData => {
	const userType = userData?.user?.userType || userData?.userType;
	const subscription = userData?.user?.subscription || userData?.subscription;
	const subscriptionType = userData?.user?.subscriptionType || userData?.subscriptionType;
	const planType = userData?.user?.planType || userData?.planType;

	return (
		[userType, subscription, subscriptionType, planType]
			.filter(Boolean)
			.some(value => String(value).toLowerCase() === 'studio' || String(value).toLowerCase() === 'studio-owner') ||
		String(userType || '').toLowerCase() === 'subuser'
	);
};

export const shouldShowStudioHub = isStudioUser;

export const getStudioHubLabel = userData => (shouldShowStudioHub(userData) ? 'Studio Hub' : 'Teacher Resource Center');

export const getStudioHubBasePath = userData => (shouldShowStudioHub(userData) ? '/studio-hub' : '/trc');

export const getStudioHubBannerSrc = userData =>
	shouldShowStudioHub(userData)
		? import.meta.env.VITE_APP_STUDIO_HUB_BANNER || '/studio-hub-banner.jpg'
		: import.meta.env.VITE_APP_TRC_BANNER;
